import { DateBuilder } from '@imcc/utilities';
import { createDateRangeReducer } from './create-date-range-reducer';

function endOfDay(date) {
  return new DateBuilder(date).endOfDay().date;
}

export const setDateRangeToReducer = createDateRangeReducer('to', endOfDay);
